document.addEventListener("DOMContentLoaded", () => {
    //
    // Wordpress sub-menu handling
    //
    const toggleLinks = document.querySelectorAll(
        ".menu-item-has-children > a[href='#']"
    );

    const allSubMenus = document.querySelectorAll(".sub-menu");
    const parentMenuItems = document.querySelectorAll(
        ".menu-item-has-children"
    );

    const isMobileDevice = () =>
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        ) ||
        (navigator.maxTouchPoints && navigator.maxTouchPoints > 2) ||
        window.innerWidth <= 991;

    const showSubMenu = (subMenu) => {
        if (subMenu && subMenu.classList.contains("sub-menu")) {
            subMenu.style.display = "flex";
        }
    };

    const hideSubMenu = (subMenu) => {
        if (subMenu && subMenu.classList.contains("sub-menu")) {
            subMenu.style.display = "none";
        }
    };

    const hideAllSubMenus = () => {
        allSubMenus.forEach((menu) => (menu.style.display = "none"));
    };

    // Click functionality (for mobile and as fallback)
    toggleLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();

            const subMenu = event.currentTarget.nextElementSibling;
            if (!subMenu || !subMenu.classList.contains("sub-menu")) return;

            const isVisible = getComputedStyle(subMenu).display === "flex";

            // Close all submenus
            hideAllSubMenus();

            // Open current one if it wasn't already open
            if (!isVisible) {
                showSubMenu(subMenu);
            }
        });
    });

    // Store hover event listeners for cleanup
    let hoverEventListeners = [];

    const setupHoverFunctionality = () => {
        // Clean up existing hover listeners
        hoverEventListeners.forEach(({ element, event, handler }) => {
            element.removeEventListener(event, handler);
        });
        hoverEventListeners = [];

        // Only add hover functionality on desktop
        if (!isMobileDevice()) {
            parentMenuItems.forEach((parentItem) => {
                const subMenu = parentItem.querySelector(".sub-menu");
                if (!subMenu) return;

                let hoverTimeout;

                const mouseEnterHandler = () => {
                    clearTimeout(hoverTimeout);

                    // Hide all other submenus first
                    allSubMenus.forEach((menu) => {
                        if (menu !== subMenu) {
                            hideSubMenu(menu);
                        }
                    });

                    // Show current submenu
                    showSubMenu(subMenu);
                };

                const mouseLeaveHandler = () => {
                    hoverTimeout = setTimeout(() => {
                        hideSubMenu(subMenu);
                    }, 100); // Small delay to prevent flickering
                };

                const subMenuEnterHandler = () => {
                    clearTimeout(hoverTimeout);
                };

                const subMenuLeaveHandler = () => {
                    hoverTimeout = setTimeout(() => {
                        hideSubMenu(subMenu);
                    }, 100);
                };

                parentItem.addEventListener("mouseenter", mouseEnterHandler);
                parentItem.addEventListener("mouseleave", mouseLeaveHandler);
                subMenu.addEventListener("mouseenter", subMenuEnterHandler);
                subMenu.addEventListener("mouseleave", subMenuLeaveHandler);

                // Store for cleanup
                hoverEventListeners.push(
                    {
                        element: parentItem,
                        event: "mouseenter",
                        handler: mouseEnterHandler,
                    },
                    {
                        element: parentItem,
                        event: "mouseleave",
                        handler: mouseLeaveHandler,
                    },
                    {
                        element: subMenu,
                        event: "mouseenter",
                        handler: subMenuEnterHandler,
                    },
                    {
                        element: subMenu,
                        event: "mouseleave",
                        handler: subMenuLeaveHandler,
                    }
                );
            });
        }
    };

    // Initial setup
    setupHoverFunctionality();

    // Hide submenus when clicking outside (keep existing functionality)
    document.addEventListener("click", (event) => {
        const isInsideMenu = event.target.closest(".tabbed-navigation");
        if (!isInsideMenu) {
            hideAllSubMenus();
        }
    });

    // Handle window resize to re-evaluate mobile/desktop state
    let resizeTimeout;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            // Hide all submenus on resize to prevent display issues
            hideAllSubMenus();

            // Re-setup hover functionality based on current screen size
            setupHoverFunctionality();
        }, 250);
    });

    //
    // Burger menu
    //
    const burgerButton = document.querySelector(".js-burger");
    const tabPane = document.querySelector(".js-tab-pane.show.active");

    const removeOpenOnWideScreen = () => {
        if (
            window.innerWidth > 768 &&
            burgerButton.classList.contains("open")
        ) {
            burgerButton.classList.remove("open");
            tabPane.classList.remove("open");
        }
    };

    if (burgerButton && tabPane) {
        burgerButton.addEventListener("click", () => {
            burgerButton.classList.toggle("open");
            tabPane.classList.toggle("open");

            if (burgerButton.classList.contains("open")) {
                document.body.classList.add("no-scroll");
            } else {
                document.body.classList.remove("no-scroll");
            }
        });

        removeOpenOnWideScreen();
        window.addEventListener("resize", removeOpenOnWideScreen);

        document.addEventListener("click", (e) => {
            const isClickInsideBurger = burgerButton.contains(e.target);
            const isClickInsideTabPane = tabPane.contains(e.target);

            if (!isClickInsideBurger && !isClickInsideTabPane) {
                burgerButton.classList.remove("open");
                tabPane.classList.remove("open");
            }
        });
    }
});
